export default "__VITE_ASSET__0c6eee5c__"